const messages = {
  es: {
    translations: {
      mutes: {
        menuMute: "Silenciar notificaciones…",
        menuUnmute: "Reactivar sonido",
        title: "Silenciar notificaciones",
        d8h: "8 horas",
        d1w: "1 semana",
        always: "Siempre",
        hint: "Los mensajes siguen llegando y contando como no leídos; solo el sonido y los avisos se detienen.",
        groupHint: "Las menciones al número de la conexión aún avisan.",
        tooltipUntil: "Silenciada hasta {{date}}",
        tooltip: "Silenciada",
        confirm: "Silenciar",
        cancel: "Cancelar",
      },
      copilot: {
        button: "Sugerir respuesta",
        loading: "Generando...",
        tooltip: "Generar un borrador de respuesta con IA (revise antes de enviar)",
        summarize: "Resumir atención",
        instructions: {
          title: "Cómo responder",
          default: "Estándar",
          shorter: "Más corto",
          formal: "Más formal",
          invoice: "Explicar factura",
        },
        dialog: {
          title: "Resumen de la atención",
          loading: "Generando resumen con IA...",
          empty: "No fue posible generar un resumen para esta atención.",
          hint: "Generado por IA a partir de la conversación y los datos del ERP vinculados. Revíselo antes de usar.",
          save: "Guardar como nota",
          savedLabel: "Nota guardada",
          copy: "Copiar",
          close: "Cerrar",
        },
        toasts: {
          inserted: "Borrador insertado — revise antes de enviar",
          empty: "La IA no devolvió sugerencia para esta conversación.",
          copied: "Resumen copiado",
          saved: "Resumen guardado como nota interna",
        },
        settings: {
          title: "Copiloto (IA)",
          enabled: "Habilitar copiloto",
          enabledHelper: "Sugerencias de respuesta y resúmenes en la atención.",
          apiKey: "Clave OpenAI",
          apiKeyHelper: "Pegue la clave y salga del campo para guardar.",
          apiKeyConfigured: "Clave configurada. Escriba una nueva para reemplazarla.",
          model: "Modelo",
          modelHelper: "gpt-4o-mini es el más barato y rápido.",
          summarizeOnTransfer: "Resumir al transferir",
          summarizeOnTransferHelper: "Genera una nota con el resumen al transferir el ticket.",
          saved: "Configuración actualizada.",
          keySaved: "Clave guardada.",
          saveError: "No fue posible guardar la configuración.",
        },
      },
      auditLogs: {
        title: "Auditoría",
        subtitle: "Quién hizo qué, cuándo y en qué empresa",
        filters: {
          company: "Empresa",
          entity: "Entidad",
          action: "Acción",
          actorEmail: "E-mail del usuario",
          dateFrom: "Desde",
          dateTo: "Hasta",
          all: "Todas",
          apply: "Filtrar",
          clear: "Limpiar",
          refresh: "Actualizar",
        },
        table: {
          date: "Fecha/hora",
          actor: "Quién",
          company: "Empresa",
          action: "Acción",
          entity: "Entidad",
          route: "Ruta",
          status: "Estado",
          details: "Detalles",
          actorCompany: "Empresa del usuario",
          changes: "Datos enviados (enmascarados)",
          noChanges: "La solicitud no tenía cuerpo.",
        },
        pagination: { showing: "Mostrando", of: "de", prev: "Anterior", next: "Siguiente" },
        empty: {
          title: "No se encontraron registros",
          message: "Ajusta los filtros o espera nuevas acciones en el sistema.",
        },
        actions: {
          create: "Creación",
          update: "Edición",
          delete: "Eliminación",
          login: "Inicio de sesión",
          logout: "Cierre de sesión",
          other: "Otra",
        },
        entities: {
          company: "Empresa",
          plan: "Plan",
          user: "Usuario",
          queue: "Cola",
          whatsapp: "Conexión",
          setting: "Configuración",
          queueIntegration: "Integración",
          contact: "Contacto",
          contactList: "Lista de contactos",
          quickMessage: "Respuesta rápida",
          campaign: "Campaña",
          tag: "Etiqueta",
          schedule: "Agendamiento",
          announcement: "Aviso",
          invoice: "Factura",
          subscription: "Suscripción",
          ticketNote: "Nota del ticket",
          ticket: "Ticket",
          session: "Sesión",
          isp: "ERP / ISP",
          other: "Otra",
        },
      },
      terms: {
        title: "Términos de uso",
        description: "Para seguir usando el sistema, el administrador de la empresa debe leer y aceptar los términos de uso.",
        readLink: "Leer los términos de uso",
        version: "Versión",
        accept: "He leído y acepto los términos",
        accepted: "Términos de uso aceptados.",
        adminMustAccept: "El administrador de la empresa debe aceptar los términos de uso.",
        acceptPrefix: "He leído y acepto los",
        acceptLink: "términos de uso",
        mustAccept: "Debes aceptar los términos de uso para registrarte.",
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        hero: {
          title: "Atención inteligente por WhatsApp para tu negocio",
          subtitle: "Centraliza conversaciones, automatiza respuestas y acompaña a tu equipo en un solo lugar.",
          feature1: "WhatsApp oficial y no oficial",
          feature2: "IA e integraciones",
          feature3: "Campañas y cobros",
        },
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        queueFilter: "Fila",
        allQueues: "Todas las filas",
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets aguardando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Dectratores",
        },
      },
      reports: {
        title: "Reporte de Pesquisas Realizadas",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      metaSignup: {
        coexTitle: "Conectar número de la app WhatsApp Business",
        coexReady: "Haga clic abajo, entre con Facebook y elija el número que ya usa en la app WhatsApp Business. Luego confirme en el celular. La app sigue funcionando.",
        coexSync: {
          none: "Coexistencia activa: el número también sigue en la app del celular.",
          requested: "Pedimos a Meta los contactos y el historial de la app. Llegan en unos minutos.",
          importing: "Importando el historial de la app… {{count}} mensajes hasta ahora.",
          done: "Historial de la app importado ({{count}} mensajes).",
          declined: "El dueño del número no autorizó compartir el historial. Los mensajes nuevos llegan normalmente.",
          failed: "Meta no aceptó el pedido de contactos/historial. Intente \"Sincronizar de nuevo\" (solo en las primeras 24 h)."
        },
        title: "Conectar WhatsApp por Meta",
        waiting: "Esperando la pantalla de Conexiones…",
        loadingSdk: "Cargando Meta…",
        ready: "Haz clic abajo para entrar con Facebook y elegir (o crear) la cuenta de WhatsApp Business y el número.",
        button: "Conectar con Facebook",
        working: "Registrando el número…",
        done: "¡Conectado! Ya puedes cerrar esta ventana.",
        cancelled: "Conexión cancelada. Cierra esta ventana e inténtalo de nuevo.",
        notEnabled: "La conexión automática no está disponible para tu empresa. Contacta al soporte.",
        fb: "Termina en la ventana de Meta…",
        errors: {
          ERR_META_COEX_ONLY: "Esta conexión no es de coexistencia.",
          ERR_META_COEX_SYNC_EXPIRED: "Meta solo acepta el pedido de historial en las 24 h siguientes a la conexión.",
          sdk: "No se pudo cargar Meta. Desactiva bloqueadores de anuncios para este sitio e inténtalo de nuevo.",
          onlyWaba: "La ventana creó la cuenta de WhatsApp Business pero no se agregó ningún número. Haz clic de nuevo y registra un número.",
          noIds: "Meta no devolvió los datos del número a tiempo. Haz clic de nuevo.",
          ERR_META_SIGNUP_CODE: "Meta no aceptó el código (vale 30 segundos). Inténtalo de nuevo.",
          ERR_META_SIGNUP_SCOPE: "La cuenta elegida no concedió acceso a WhatsApp. Repite eligiendo la cuenta y todos los permisos.",
          ERR_META_SIGNUP_PHONE: "El número elegido no pertenece a la cuenta de WhatsApp Business seleccionada.",
          ERR_META_NUMBER_IN_USE: "Este número ya está conectado en otra empresa.",
          ERR_META_SIGNUP_RATE_LIMIT: "Demasiados intentos. Espera 10 minutos.",
          ERR_META_SIGNUP_NOT_CONFIGURED: "La app de Meta de la plataforma aún no está configurada.",
          ERR_NO_PERMISSION: "Solo el administrador de la empresa puede conectar números.",
          generic: "No se pudo completar. Inténtalo de nuevo o contacta al soporte."
        },
        status: {
          ok: "Número activo en la API oficial.",
          pin_required: "El número ya tenía verificación en dos pasos. Ingresa el PIN de 6 dígitos para terminar.",
          not_registered: "Conexión creada, pero falló el webhook/registro. Usa \"Conectar por Meta\" de nuevo con el mismo número.",
          review_pending: "Conexión creada. La cuenta sigue en revisión en Meta; el envío queda limitado hasta la aprobación."
        }
      },
      connections: {
        webchat: {
          menu: "Webchat (página de atención en el navegador)",
          copyLink: "Copiar enlace",
          openPage: "Abrir página",
          linkCopied: "Enlace copiado",
          active: "Página en línea",
          inactive: "Página desactivada",
        },
        metaSignup: {
          coexMenu: "Número de la app WhatsApp Business (coexistencia)",
          chip: { pin_required: "PIN pendiente", not_registered: "Registro pendiente", review_pending: "En revisión en Meta", coexistence: "Coexistencia" },
          menu: "Conectar por Meta (automático)",
          manual: "WhatsApp Oficial (registro manual)",
          popupBlocked: "El navegador bloqueó la ventana. Permite ventanas emergentes para este sitio e inténtalo de nuevo.",
          done: "¡Número conectado por Meta!",
          pinRequired: "Conexión creada. Ingresa el PIN de dos pasos en la pantalla de la conexión."
        },
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        newConnection: "Nueva Conexión",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "iniciou la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
        },
      },
      whatsappModal: {
        webchat: {
          tab: "Página",
          section: "Página del webchat",
          title: "Título de la página",
          titleHelp: "Aparece en la parte superior de la página. Vacío = nombre de la conexión.",
          welcomeText: "Texto de bienvenida",
          welcomeHelp: "Se muestra antes de que el cliente empiece (hasta 500 caracteres).",
          requirePhone: "Pedir el WhatsApp del cliente",
          link: "Enlace para enviar a los clientes",
          linkPending: "El enlace aparece después de guardar.",
          subtitle: " · Webchat",
          closingSection: "Mensaje de cierre",
        },
        metaSignup: {
          coexTitle: "Coexistencia con la app WhatsApp Business",
          coexHint: "El número sigue en el celular. Lo que responda por la app aparece aquí; el bot no responde encima de esos mensajes.",
          coexResync: "Sincronizar de nuevo",
          title: "Conectado por Meta",
          review: "Revisión de la cuenta",
          quality: "Calidad",
          sendPin: "Enviar PIN",
          pinLabel: "PIN (6 dígitos)",
          reconnectHint: "Para renovar el acceso, usa Nueva Conexión → Conectar por Meta y elige el mismo número."
        },
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "Geral",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          prompt: "Prompt",
          triggerIntegrationOnClose:
            "Integración de activadores al cerrar un ticket",
          enableIntegration: "Activadore Integración",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "La conversación fluye",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Máximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          webchatNumber: "Contacto del webchat: el número es interno y no se puede cambiar.",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
      },
      sla: {
        kind: { firstResponse: "1ª respuesta", resolution: "Resolución" },
        status: { ok: "En plazo", warning: "Atención", breached: "Vencido" },
        toast: {
          breached: "SLA vencido ({{kind}}): {{contact}}",
          breachedWithQueue: "SLA vencido ({{kind}}): {{contact}} ({{queue}})",
          unknownContact: "contacto",
        },
        dashboard: {
          title: "SLA",
          hint: "Cumplimiento de las metas de tiempo en el período y fila filtrados",
          pctFirst: "1ª respuesta en plazo",
          pctResolution: "Resolución en plazo",
          avgFirstResponse: "1ª respuesta promedio",
          avgResolution: "Resolución promedio",
          total: "{{count}} atenciones con SLA",
        },
      },
      aiLearning: {
        title: "Aprendizaje de la IA",
        subtitle: "Cómo los agentes de IA de esta empresa mejoran con las atenciones resueltas",
        refresh: "Actualizar",
        settings: {
          title: "Configuración",
          enabled: "Aprendizaje activado",
          enabledHint: "La IA aprende de las atenciones de esta empresa — nunca de otras — y solo cambia la forma de hablar. Precios y reglas no cambian.",
          approval: "Exigir mi aprobación para lecciones nuevas",
          approvalHint: "Las lecciones nuevas quedan pendientes hasta que las apruebes o rechaces aquí.",
          saved: "Configuración guardada",
          noAgent: "Esta empresa aún no tiene agente de IA (integración de IA o prompt). El aprendizaje empieza cuando haya uno.",
          cost: "Costo: las llamadas del aprendizaje solo aparecen en Uso de IA cuando usan la clave de la plataforma. Una integración con clave propia se cobra directo en la cuenta OpenAI de la empresa y no aparece aquí.",
        },
        lastRun: {
          title: "Última ejecución",
          never: "Aún no se ejecutó. La rutina corre de madrugada (04:00).",
          at: "{{date}}",
          summary: "{{evaluated}} atenciones evaluadas · {{created}} lecciones nuevas · {{reinforced}} reforzadas · {{discarded}} descartadas · {{memories}} memorias de cliente",
          discardedBy: "Descartadas por: {{list}}",
          cost: "Costo de la ejecución (clave de la plataforma): {{value}}",
          skipped: "No aprendió nada: {{reason}}",
        },
        skipped: {
          disabled: "aprendizaje desactivado en esta empresa",
          no_agent: "la empresa no tiene agente de IA",
          quota: "límite de uso de IA del plan alcanzado",
          volume: "pocas atenciones exitosas (mínimo 10)",
          no_key: "ninguna clave de OpenAI disponible (propia o de la plataforma)",
          platform_off: "rutina desactivada en la plataforma",
          locked: "otra ejecución estaba en curso",
          extractionPrefix: "al extraer lecciones: {{reason}}",
        },
        discard: {
          pii: "dato personal",
          filter: "regla de seguridad",
          regra: "regla de seguridad",
          from_customer: "vino del cliente, no del equipo",
          judge: "rechazada en la revisión",
          judge_injection: "lote con instrucción sospechosa",
        },
        cards: {
          successRate: "Éxito esta semana",
          pp: "{{value}} p.p.",
          vsLastWeek: "vs semana anterior",
          noData: "sin atenciones",
          aiShare: "Conducidas por la IA",
          aiShareHint: "solo IA {{ai}} · mixta {{mixed}}",
          evaluated: "Atenciones evaluadas",
          evaluatedHint: "en las últimas {{weeks}} semanas",
          activeLessons: "Lecciones activas",
          pendingHint: "{{count}} esperando aprobación",
        },
        chart: {
          title: "Tasa de éxito por semana",
          hint: "Atenciones cerradas con éxito sobre el total de la semana",
          tooltip: "Semana del {{week}}: {{success}} de {{total}} ({{rate}})",
          empty: "sin datos",
          week: "Semana",
          success: "Éxito",
          total: "Total",
        },
        funnel: {
          title: "Embudo de ventas",
          chegou: "Llegó",
          cotou: "Cotizó",
          proposta: "Recibió propuesta",
          fechou: "Cerró",
        },
        stops: {
          title: "Dónde se detienen los clientes",
          hint: "Atenciones sin éxito, por el momento en que el cliente se detuvo",
          empty: "Nada registrado aún.",
        },
        reasons: {
          title: "Motivos",
          empty: "Nada registrado aún.",
          fatura_em_aberto: "factura sigue pendiente",
          reaberto_48h: "el cliente volvió en 48 h",
          sem_mensagem_cliente: "el cliente no escribió",
          sem_resposta_humana: "sin respuesta del equipo",
        },
        lessons: {
          title: "Lecciones",
          hint: "Lo que la IA aprendió y usa en las conversaciones. Desactiva lo que no tenga sentido.",
          text: "Lección",
          origin: "Origen",
          agent: "Agente",
          weight: "Peso",
          lastSeen: "Visto por última vez",
          status: "Situación",
          showExample: "Ver ejemplo",
          hideExample: "Ocultar ejemplo",
          approve: "Aprobar",
          reject: "Rechazar",
          toggle: "Lección activa",
          updated: "Lección actualizada",
          emptyTitle: "Aún aprendiendo",
          emptyMessage: "Las primeras lecciones aparecen después de la primera noche con al menos 10 atenciones exitosas.",
          filterEmpty: "Ninguna lección en esta situación.",
          originLabels: {
            human: "Equipo",
            ai: "IA",
            mixed: "Equipo + IA",
          },
          agentLabels: {
            hospedagem: "Hospedaje",
            isp: "Soporte ISP",
            generic: "Prompt/IA",
            none: "—",
          },
          statusLabels: {
            all: "Todas",
            active: "Activa",
            pending: "Pendiente",
            disabled: "Desactivada",
            expired: "Vencida",
          },
        },
      },
      ratings: {
        title: "Evaluaciones",
        subtitle: "Notas dadas por los clientes al final de la atención, por agente",
        refresh: "Actualizar",
        cards: {
          total: "Evaluaciones",
          avg: "Promedio (0–10)",
          otimo: "% Excelente",
          ruim: "% Malo",
          responseRate: "Tasa de respuesta",
        },
        filters: {
          dateFrom: "Desde",
          dateTo: "Hasta",
          attendant: "Agente",
          allAttendants: "Todos",
          queue: "Cola",
          allQueues: "Todas",
          apply: "Filtrar",
        },
        labels: {
          otimo: "Excelente",
          regular: "Regular",
          ruim: "Malo",
        },
        attendants: {
          title: "Por agente",
          hint: "Ordenado por el promedio del período",
          name: "Agente",
          avg: "Promedio",
          count: "Evaluaciones",
          distribution: "Excelente / Regular / Malo",
          closedTickets: "Tickets cerrados",
          responseRate: "% respuesta",
          empty: "Sin evaluaciones en el período",
        },
        list: {
          title: "Evaluaciones recibidas",
          hint: "Más recientes primero",
          date: "Fecha",
          contact: "Contacto",
          attendant: "Agente",
          queue: "Cola",
          rate: "Nota",
          ticket: "Ticket",
          showing: "Mostrando {{from}}–{{to}} de {{count}}",
          prev: "Anterior",
          next: "Siguiente",
          emptyTitle: "No se encontraron evaluaciones",
          emptyMessage: "Ajuste el período o los filtros. Las evaluaciones aparecen cuando el cliente responde la pregunta enviada al cerrar la atención.",
        },
      },
      supervision: {
        title: "Supervisión",
        subtitle: "Fila de espera, agentes y SLA en tiempo real",
        refresh: "Actualizar",
        updatedAt: "Actualizado {{time}}",
        cards: {
          waiting: "En espera",
          oldestWaiting: "Más antiguo en espera",
          open: "En atención",
          breached: "SLA vencido ahora",
          online: "Agentes en línea",
        },
        queues: {
          title: "Filas",
          hint: "Situación de cada fila ahora y cumplimiento del SLA hoy",
          queue: "Fila",
          waiting: "En espera",
          oldest: "Más antiguo",
          open: "En atención",
          warning: "Aviso",
          breached: "Vencidos",
          slaToday: "% en SLA hoy",
          noSla: "sin meta",
          emptyTitle: "Ninguna fila tiene SLA configurado",
          emptyMessage: "Defina las metas de 1ª respuesta y resolución en Filas & Chatbot → editar fila → sección SLA.",
          emptyAction: "Ir a Filas",
        },
        agents: {
          title: "Agentes",
          hint: "Quién está en línea y la carga de cada uno",
          online: "En línea",
          offline: "Desconectado",
          lastSeen: "visto {{ago}}",
          openTickets: "Abiertos",
          breached: "Vencidos",
          avgFirstResponse: "1ª respuesta hoy",
          empty: "Ningún agente registrado",
        },
        time: {
          now: "ahora",
          minutes: "hace {{count}} min",
          hours: "hace {{count}} h",
          days: "hace {{count}} d",
          never: "nunca",
        },
        forbidden: "No tiene permiso para acceder a esta página",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          slaTitle: "SLA (metas de tiempo)",
          slaFirstResponse: "1ª respuesta (min)",
          slaResolution: "Resolución (min)",
          slaWarning: "Aviso en (%)",
          slaHint: "Vacío = sin meta. El aviso (ámbar) aparece al alcanzar el porcentaje de la meta.",
          tipoIntegracao: "Tipo de Integración (ERP)",
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      erp: {
        integrationTypes: {
          NA: "Ninguna",
          SB: "2ª vía de boleto",
          AV: "Por vencer",
          VE: "Vencidas",
          LC: "Liberación por confianza",
          ST: "Estado de la conexión",
        },
        sgpModes: {
          auto: "Automático (URA si App y Token están completos)",
          central: "Solo central del abonado",
          ura: "Solo API URA",
        },
        validation: {
          nameRequired: "El nombre de la integración es obligatorio.",
          sgpUrlRequired: "SGP URL es obligatorio.",
          sgpAppRequired: "Informe el App del SGP para usar el modo Solo API URA.",
          sgpTokenRequired: "Informe el Token de la app del SGP para usar el modo Solo API URA.",
          sgpUraPairRequired: "Informe App y Token de la app juntos para habilitar la API URA del SGP.",
          sgpModeInvalid: "Modo del SGP inválido.",
          ixcUrlRequired: "La URL base del IXC es obligatoria.",
          ixcTokenRequired: "El token de la API IXC es obligatorio.",
          urlInvalid: "URL inválida. Use el formato https://...",
          timeoutInvalid: "El timeout debe ser un número mayor que cero.",
          erpIntegrationRequired: "Seleccione la integración ERP (SGP o IXC).",
          openaiApiKeyRequired: "La clave de la API OpenAI es obligatoria.",
          maxTurnsInvalid: "El máximo de turnos debe ser un número entero mayor que cero.",
          hotspotBaseUrlRequired: "La URL del Hotspot es obligatoria.",
          hotspotApiKeyRequired: "La clave de API del Hotspot es obligatoria.",
          hospedagemProviderRequired: "Seleccione el proveedor de hospedaje.",
          hospedagemBaseUrlRequired: "La URL del sitio es obligatoria.",
          hospedagemApiKeyRequired: "La clave de API es obligatoria.",
          hospedagemIntegrationRequired: "Seleccione el conector de hospedaje.",
          hospedagemNomeAgenteRequired: "El nombre del agente es obligatorio.",
          hospedagemNomeEmpresaRequired: "El nombre de la empresa es obligatorio.",
          hospedagemPersonaRequired: "La persona del agente es obligatoria.",
        },
      },
      systemResources: {
        title: "Servidor",
        subtitle: "Uso de hardware de la máquina donde corre el sistema",
        collectedAt: "Recogido a las {{time}}",
        autoRefresh: "Actualizar cada 15 s",
        refresh: "Actualizar",
        live: "en vivo",
        loading: "Cargando…",
        error: "No se pudieron leer los recursos del servidor.",
        cpu: "CPU",
        cpuHint: "{{cores}} núcleos · carga {{load}}",
        memory: "Memoria",
        disk: "Disco",
        uptime: "Servidor activo hace",
        processUptime: "backend activo hace {{time}}",
        cpuSection: "Procesador",
        cpuUsage: "Uso de CPU",
        cpuSample: "Promedio de todos los núcleos en 0,5 s",
        cpuModel: "Modelo",
        cores: "Núcleos",
        loadAvg: "Carga media (1 · 5 · 15 min)",
        memorySection: "Memoria",
        ram: "RAM",
        swap: "Swap",
        memoryHint: "{{available}} disponibles",
        total: "Total",
        used: "En uso",
        available: "Disponible",
        disksSection: "Discos",
        diskHint: "{{used}} de {{size}} · {{free}} libres",
        noDisk: "Ningún disco encontrado",
        processSection: "Proceso y base de datos",
        node: "Node.js",
        processUptimeLabel: "Backend activo hace",
        rss: "Memoria del backend (RSS)",
        heap: "Heap usado / total",
        database: "Base de datos",
        databaseSize: "Tamaño de la base",
      },
      aiUsage: {
        title: "Uso de IA",
        used: "Usado en el mes",
        credit: "Cuota del plan",
        cap: "Tope",
        extra: "Crédito extra",
        kinds: { chat: "Conversación", transcription: "Transcripción de audio", tts: "Respuesta en voz" },
        noCredit: "Su plan no incluye IA con la clave de la plataforma.",
        onlyMeasuring: "Modo medición: el consumo se registra pero nunca bloquea.",
        byDay: "Consumo por día",
        history: "Historial",
        model: "Modelo",
        date: "Fecha",
        value: "Valor",
        noUsage: "Ningún consumo registrado este mes.",
        companyColumn: "IA (mes)",
        platform: {
          metaApp: {
            title: "App de Meta (API oficial)",
            appId: "ID de la app",
            configId: "Configuration ID (Embedded Signup)",
            secret: "Clave secreta de la app",
            secretSet: "••••••• (guardada)",
            fromEnv: "del .env",
            save: "Guardar",
            saved: "App de Meta guardada.",
            help: "Con los tres valores, el botón \"Conectar por Meta\" aparece en Conexiones para las empresas cuyo plan permite la API oficial."
          },
          title: "IA de la plataforma",
          subtitle: "Clave compartida, tabla de precios y consumo por empresa",
          settings: "Configuración",
          key: "Clave OpenAI de la plataforma",
          keySet: "Clave configurada",
          keyPlaceholder: "Pegue la clave (no se muestra después)",
          usdBrl: "Cambio US$ → R$",
          multiplier: "Multiplicador de ganancia",
          visionModel: "Modelo de visión (lectura de fotos/PDF)",
          visionModelHelp: "Predeterminado gpt-4o-mini. Usado por el nodo \"Leer archivo\".",
          quotaMessage: "Mensaje al cliente cuando se agota la cuota",
          prices: "Tabla de precios (US$)",
          model: "Modelo",
          inputPerMillion: "Entrada / 1M tokens",
          outputPerMillion: "Salida / 1M tokens",
          audioPerMinute: "Audio / minuto",
          ttsPerMillionChars: "Voz / 1M caracteres",
          active: "Activo",
          addModel: "Agregar modelo",
          newModelPrompt: "Nombre del modelo (ej.: gpt-4o-mini)",
          companies: "Consumo por empresa",
          company: "Empresa",
          period: "Período",
          used: "Usado",
          cost: "Costo",
          charged: "Cobrado",
          profit: "Ganancia",
          credit: "Cuota",
          cap: "Tope",
          enforce: "Bloquear al alcanzar el tope",
          enforceOn: "Bloquea",
          enforceOff: "Solo mide",
          extraCredit: "Liberar crédito extra",
          extraCreditPrompt: "Crédito extra (R$) para este mes:",
          extraCreditSaved: "Crédito extra liberado",
          enforceSaved: "Bloqueo actualizado",
          close: "Cerrar mes",
          confirmClose: "¿Cerrar el mes {{period}}? Se generarán los extractos y el excedente entra en la próxima factura.",
          closed: "Mes cerrado: {{n}} extractos, excedente R$ {{v}}",
          noCompanies: "Ninguna empresa consumió IA en este período.",
          saved: "Guardado",
          save: "Guardar"
        },
        plan: { credit: "Crédito de IA/mes (R$)", multiplier: "Tope (× cuota)" }
      },
      billingRules: {
        title: "Regla de cobranza",
        buttons: {
          new: "Nueva regla",
          create: "Crear regla",
          save: "Guardar",
          cancel: "Cancelar",
          close: "Cerrar",
          preview: "Vista previa",
          runNow: "Ejecutar ahora",
          history: "Historial",
          testSend: "Enviar prueba a un número",
          edit: "Editar",
          delete: "Eliminar",
        },
        stage: {
          beforeDays: "{{count}} día antes",
          beforeDays_plural: "{{count}} días antes",
          due: "En el vencimiento",
          afterDays: "{{count}} día después",
          afterDays_plural: "{{count}} días después",
        },
        table: {
          copyButtons: "Botones de copiar (PIX / código de barras / abrir boleto)",
          copyButtonsShort: "Botones",
          sendPdf: "Adjunta el PDF del boleto después del mensaje",
          name: "Nombre",
          stage: "Etapa",
          erp: "ERP",
          connection: "Conexión",
          template: "Plantilla / texto",
          sendHour: "Hora",
          active: "Activa",
          lastRun: "Última ejecución",
          actions: "Acciones",
          metaTemplate: "Plantilla Meta (WhatsApp oficial)",
          officialConnection: "WhatsApp oficial (Meta)",
          viewCampaign: "Ver campaña",
        },
        totals: {
          total: "Total",
          sent: "Enviadas",
          failed: "Fallidas",
          skipped: "Omitidas",
        },
        modal: {
          newTitle: "Nueva regla de cobranza",
          editTitle: "Editar regla de cobranza",
        },
        form: {
          sendPdf: "Adjuntar PDF del boleto (WhatsApp no oficial)",
          sendPdfHelp: "Después del texto, el boleto en PDF se envía como documento. Si el PDF falla, el texto sigue contando como enviado.",
          sendPdfOfficialHelp: "Solo en conexiones no oficiales. WhatsApp oficial (Meta) envía solo la plantilla aprobada.",
          copyButtons: "Botones de copiar (Copiar PIX · Copiar código de barras · Abrir boleto)",
          copyButtonsHelp:
            "El cliente recibe el texto sin los códigos largos y tres botones nativos de WhatsApp: Copiar PIX, Copiar código de barras y Abrir boleto. Si el dispositivo no acepta botones, sale el texto completo con los códigos.",
          copyButtonsOfficialHelp:
            "En WhatsApp oficial Meta no permite botón de copiar códigos largos (límite de 15 caracteres). Marque para completar el botón de enlace \"Abrir boleto\" de la plantilla (URL dinámica https://…/b/{{1}}); PIX y línea digitable van en el cuerpo.",
          name: "Nombre de la regla",
          erpIntegration: "Integración ERP",
          whatsapp: "Conexión WhatsApp",
          official: "oficial",
          none: "Ninguno",
          stage: "Cuándo enviar",
          stageBefore: "Antes del vencimiento",
          stageDue: "El día del vencimiento",
          stageAfter: "Después del vencimiento",
          offsetDays: "Días",
          sendHour: "Hora de envío",
          metaTemplate: "Plantilla aprobada",
          metaTemplateHelp: "Solo las plantillas aprobadas por Meta pueden usarse en esta conexión.",
          loadingTemplates: "Cargando plantillas…",
          noApprovedTemplates: "No hay plantilla aprobada para esta conexión. Cree y apruebe una en Plantillas WhatsApp.",
          goToTemplates: "Ir a Plantillas WhatsApp",
          variablesHelp: "Haga clic en una variable para insertarla en el texto:",
          textTemplate: "Texto del mensaje",
          defaultTemplate:
            "¡Hola {nome}! Su factura de {valor} vence el {vencimento}.\n\nLínea digitable: {linhaDigitavel}\nPIX copia y pega: {pix}\n\nSi ya pagó, ignore este mensaje.",
          active: "Regla activa",
          activeHelp: "Las reglas activas se ejecutan automáticamente todos los días a la hora configurada.",
        },
        validation: {
          nameRequired: "Ingrese un nombre con al menos 2 caracteres.",
          erpRequired: "Seleccione la integración ERP.",
          whatsappRequired: "Seleccione la conexión WhatsApp.",
          stageRequired: "Seleccione la etapa.",
          offsetDaysInvalid: "Ingrese un número de días entre 1 y {{max}}.",
          sendHourInvalid: "Hora inválida.",
          templateRequired: "Seleccione una plantilla aprobada.",
          textRequired: "Ingrese el texto del mensaje.",
          fixErrors: "Corrija los campos resaltados.",
        },
        preview: {
          title: "Vista previa de la regla",
          loading: "Consultando facturas en el ERP…",
          count: "Facturas que entrarían hoy",
          warnings: "Avisos",
          samples: "Ejemplos de mensajes",
          noSamples: "No se encontró ninguna factura para esta etapa hoy.",
          dueDate: "Vencimiento",
          amount: "Valor",
        },
        runs: {
          title: "Historial de ejecuciones",
          empty: "Esta regla aún no se ha ejecutado.",
          date: "Fecha",
          status: "Estado",
          totals: "Totales",
          campaign: "Campaña",
        },
        runStatus: {
          pending: "Pendiente",
          running: "En curso",
          finished: "Finalizada",
          failed: "Falló",
          skipped: "Sin facturas",
        },
        confirm: {
          runTitle: "Ejecutar ahora la regla",
          runMessage: "Se creará una campaña de facturas y los mensajes comenzarán a enviarse de inmediato. ¿Desea continuar?",
          deleteTitle: "Eliminar la regla",
          deleteMessage: "La regla dejará de ejecutarse. Las campañas ya generadas no se eliminarán.",
        },
        testSend: {
          title: "Enviar prueba",
          help: "Toma la primera factura de la etapa de esta regla hoy y la envía solo al número indicado (mismo texto, botones y PDF del envío real). No se registra nada en la regla.",
          number: "Número con código de área (ej.: 51999998888)",
          numberInvalid: "Ingrese código de área + número (10 a 13 dígitos).",
          send: "Enviar prueba",
          sentTo: "Enviado a",
          invoiceOf: "Factura usada",
          followUp: "Siga el envío en Campañas → Campañas de factura (campaña #{{id}}).",
        },
        toasts: {
          testSent: "Prueba enviada a {{number}}. Siga en Campañas de factura.",
          created: "Regla creada.",
          updated: "Regla actualizada.",
          deleted: "Regla eliminada.",
          activated: "Regla activada.",
          deactivated: "Regla desactivada.",
          runStarted: "Ejecución iniciada: {{total}} factura(s) en la campaña #{{campaignId}}.",
        },
        empty: {
          noErpTitle: "Ninguna integración ERP configurada",
          noErpText: "La regla de cobranza busca las facturas en su ERP (SGP o IXC). Configure una integración en Colas & Chatbot → Integraciones para comenzar.",
          noErpAction: "Ir a Integraciones",
          noRulesTitle: "Arme su regla de cobranza",
          noRulesText: "Cada regla envía automáticamente un mensaje de WhatsApp a los clientes con factura en una etapa: unos días antes del vencimiento, el mismo día o después de vencida. Ejemplo:",
          exampleBefore: "recordatorio antes del vencimiento",
          exampleDue: "aviso el día",
          exampleAfter: "cobro de factura vencida",
        },
      },
      networkAlerts: {
        index: {
          loading: "Consultando la base del ERP…",
          updatedAt: "Base del ERP actualizada el {{date}} · {{rows}} registros",
          running: "Indexando… página {{page}} ({{indexed}} registros)",
          never: "La base de este ERP aún no fue indexada.",
          error: "La última indexación falló: {{error}}",
          reindex: "Indexar ahora",
          started: "Indexación iniciada; tarda unos minutos.",
          emptyTitle: "La base de este ERP aún no fue indexada",
          emptyMessage: "La búsqueda por área usa una copia local de la base del SGP. Pulsa Indexar ahora y espera unos minutos.",
          emptyMessageUser: "La búsqueda por área usa una copia local de la base del SGP. Pide a un administrador que indexe la base.",
        },
        title: "Problema General",
        subtitle: "Avisa a los clientes de un área afectada y deja que el bot responda mientras dure la falla.",
        activeBadge: "{{count}} en curso",
        tabs: { search: "Buscar clientes", alerts: "Alertas" },
        buttons: {
          newAlert: "Nueva alerta",
          search: "Buscar",
          createAlert: "Crear alerta para este alcance",
          broadcastNow: "Enviar aviso ahora",
          edit: "Editar",
          close: "Cerrar",
          broadcast: "Enviar aviso",
          delete: "Eliminar",
          cancel: "Cancelar",
          save: "Guardar",
          saveAndBroadcast: "Guardar y enviar",
          send: "Enviar",
          done: "Listo",
          prev: "Anterior",
          next: "Siguiente",
          viewCampaign: "Ver campaña",
          goToIntegrations: "Configurar integración ERP",
        },
        scope: {
          pon: "PON",
          olt: "OLT",
          nas: "Concentrador",
          city: "Ciudad",
          region: "Región",
          all: "Todos los clientes",
          placeholder: {
            pon: "Ej.: 1/2/3",
            olt: "Ej.: OLT-CENTRO",
            nas: "Ej.: NAS-01 o 10.0.0.1",
            city: "Ej.: Belo Horizonte",
            region: "Ej.: Zona Norte",
          },
        },
        search: {
          erp: "ERP",
          by: "Buscar por",
          value: "Valor",
          total: "cliente(s) encontrado(s)",
          page: "Página {{page}}",
          unsupported: "Este ERP no informa {{fields}}; busca por ciudad o región.",
          unsupportedBy: "Este ERP no permite buscar por {{field}}; busca por ciudad o región.",
          idle: {
            title: "Encuentra los clientes de un área",
            message: "Elige el tipo (PON, OLT, concentrador, ciudad o región), escribe el valor y pulsa Buscar.",
          },
          empty: {
            title: "Ningún cliente encontrado",
            message: "Revisa el valor o prueba otro tipo de búsqueda.",
          },
        },
        table: {
          name: "Cliente",
          contract: "Contrato",
          phones: "Teléfono(s)",
          city: "Ciudad / Barrio",
          olt: "OLT",
          pon: "PON",
          nas: "Concentrador",
        },
        filters: { active: "Activas", closed: "Cerradas", all: "Todas" },
        card: {
          status: { active: "En curso", closed: "Cerrada" },
          startsAt: "Inicio",
          endsAt: "Previsión",
          noEnds: "Sin previsión",
          affected: "Clientes afectados",
          createdBy: "Creada por",
          erp: "ERP",
          campaign: "Campaña #{{id}}",
        },
        empty: {
          noErp: {
            title: "Ninguna integración ERP configurada",
            message: "Registra una integración SGP o IXC en Colas & Chatbot → Integraciones para buscar clientes por área.",
          },
          noAlerts: {
            title: "Ninguna alerta activa",
            message: "Cómo funciona:",
            step1: "Busca los clientes del área afectada (PON, OLT, concentrador, ciudad o región).",
            step2: "Crea la alerta con un título corto y el mensaje que enviará el bot.",
            step3: "Opcional: envía el aviso ahora a todos los clientes del alcance.",
          },
          noAlertsFiltered: {
            title: "Ninguna alerta con este filtro",
            message: "Cambia el filtro para ver alertas activas o cerradas.",
          },
        },
        form: {
          titleNew: "Nueva alerta",
          titleEdit: "Editar alerta",
          subtitle: "Mientras la alerta esté activa, el bot y la IA avisan automáticamente a los clientes del alcance.",
          erp: "ERP",
          scopeType: "Alcance",
          scopeValue: "Valor del alcance",
          scopeAllHelp: "Se avisará a todos los clientes de esta integración.",
          title: "Título corto",
          titlePlaceholder: "Ej.: Falla de energía en la OLT Centro",
          message: "Mensaje para el cliente",
          messagePlaceholder: "Ej.: Nuestro equipo ya está en el lugar trabajando en la solución.",
          messageHelp: "Escribe como si hablaras con el cliente. Sin términos técnicos.",
          preview: "Cómo lo enviará el bot",
          startsAt: "Inicio",
          endsAt: "Previsión de normalización",
          endsAtHelp: "Opcional. Se incluye en el mensaje del bot.",
          active: "Alerta activa",
        },
        preview: {
          withEnds: "⚠️ {{body}}. Previsión de normalización: {{endsAt}}",
          withoutEnds: "⚠️ {{body}}.",
          placeholder: "Completa el título y el mensaje para ver la vista previa.",
        },
        validation: {
          erpRequired: "Selecciona la integración ERP.",
          scopeValueRequired: "Indica el valor del alcance.",
          titleRequired: "Indica un título.",
          messageRequired: "Indica el mensaje para el cliente.",
          endsBeforeStarts: "La previsión de normalización debe ser posterior al inicio.",
        },
        confirm: {
          closeTitle: "¿Cerrar \"{{title}}\"?",
          closeMessage: "El bot deja de avisar a los clientes de este alcance. La alerta queda en el historial.",
          deleteTitle: "¿Eliminar \"{{title}}\"?",
          deleteMessage: "Esta acción no se puede deshacer. Las campañas ya enviadas no se ven afectadas.",
        },
        broadcast: {
          testNumber: "Enviar solo a un número (prueba)",
          testNumberHelp: "Con valor: envía 1 mensaje solo a este número, con el nombre del primer cliente del alcance, sin marcar el alerta como disparado. Vacío: envía a todos.",
          title: "Enviar aviso",
          whatsapp: "Conexión",
          official: "Oficial",
          noConnections: "Ninguna conexión de WhatsApp disponible.",
          template: "Plantilla aprobada",
          templateHelp: "Las conexiones oficiales solo envían plantillas aprobadas por Meta.",
          loadingTemplates: "Cargando plantillas…",
          noTemplates: "Ninguna plantilla aprobada en esta conexión. Crea y aprueba una plantilla antes de enviar.",
          text: "Mensaje",
          textHelp: "Prellenado con el mensaje de la alerta. Puedes ajustarlo.",
          recipients: "Destinatarios",
          recipientsUnknown: "todos del alcance",
          acknowledge: "Entiendo que esto enviará {{count}} mensajes.",
          acknowledgeUnknown: "Entiendo que esto enviará un mensaje a cada cliente del alcance.",
          resultTitle: "Aviso en cola de envío",
          resultMessage: "Campaña #{{id}} creada con {{total}} mensajes. Sigue el progreso en Campañas de factura.",
        },
        toasts: {
          testSent: "Prueba del aviso enviada a {{number}}.",
          created: "Alerta creada.",
          updated: "Alerta actualizada.",
          closed: "Alerta cerrada.",
          deleted: "Alerta eliminada.",
          broadcastStarted: "Envío iniciado: {{total}} mensajes en cola.",
        },
      },
      hotspot: {
        tabelas: {
          none: "—",
          varejo: "Minorista",
          atacado: "Mayorista",
        },
        title: "Hotspot",
        subtitle: "Fichas, equipos y pagos del hotspot Wi-Fi.",
        tabs: {
          vouchers: "Fichas",
          devices: "Equipos",
          payments: "Pagos",
          summary: "Resumen",
        },
        comingSoon: "Próximamente.",
        notConfigured: {
          title: "Hotspot no configurado",
          text: "Configure la integración Hotspot en Filas y Chatbot → Integraciones para comenzar a generar fichas.",
          action: "Configurar integración",
        },
        unavailable: {
          title: "No se pudo cargar el Hotspot",
          text: "Ocurrió un error al consultar la integración. Intente nuevamente en unos instantes.",
          action: "Intentar de nuevo",
        },
        totals: {
          batches: "Lotes",
          vouchers: "Fichas",
          available: "Disponibles",
          used: "Usadas",
          canceled: "Canceladas",
        },
        search: {
          placeholder: "Buscar por nombre del lote…",
        },
        table: {
          name: "Nombre",
          device: "Equipo",
          duration: "Duración",
          quantity: "Cantidad",
          available: "Disp. / Usadas",
          status: "Estado",
          createdAt: "Creado en",
          actions: "Acciones",
          noDevice: "Sin equipo",
          empty: "No se encontraron lotes.",
        },
        batchStatus: {
          liberado: "Liberado",
          aguardando_pagamento: "Esperando pago",
        },
        buttons: {
          new: "Nuevo lote",
          viewVouchers: "Ver fichas",
          pdf: "PDF",
          copyPixLink: "Copiar link Pix",
          sendWhatsapp: "Enviar por WhatsApp",
          tryAgain: "Intentar de nuevo",
          close: "Cerrar",
          cancel: "Cancelar",
          save: "Guardar",
          copy: "Copiar",
          send: "Enviar",
        },
        toasts: {
          linkCopied: "Link copiado.",
          pixCopied: "Código Pix copiado.",
          codeCopied: "Código copiado.",
          pdfError: "No fue posible abrir el PDF.",
          batchCreated: "Lote creado con éxito.",
          sent: "Enviado con éxito.",
        },
        newBatch: {
          title: "Nuevo lote de fichas",
          name: "Nombre del lote",
          namePlaceholder: "Ej.: Fichas del día",
          quantity: "Cantidad",
          duration: "Duración",
          durationCustom: "Otra duración",
          durationCustomPlaceholder: "Valor",
          durationUnit: "Unidad",
          units: { min: "Minutos", h: "Horas", d: "Días" },
          device: "Equipo",
          deviceDefault: "Predeterminado de la integración",
          priceLabel: "Etiqueta del precio (opcional)",
          priceLabelPlaceholder: "Ej.: R$ 5,00 / 2h",
          wholesale: "Precio al por mayor (R$)",
          retail: "Precio al por menor (R$)",
          generateCharge: "Generar cobro Pix",
          chargeRequired: "Es obligatorio generar el cobro Pix para su perfil.",
          submit: "Crear lote",
          creating: "Creando…",
          quantityInvalid: "Indique una cantidad entre 1 y 500.",
        },
        result: {
          title: "Lote creado",
          qrTitle: "Código QR Pix",
          pixCopyPaste: "Pix copiar y pegar",
          link: "Link de pago",
          done: "Concluir",
        },
        detail: {
          title: "Fichas del lote",
          code: "Código",
          status: "Estado",
          usedAt: "Usado en",
          empty: "No se encontraron fichas.",
          loading: "Cargando fichas…",
        },
        sendDialog: {
          title: "Enviar por WhatsApp",
          help: "Indique el número que recibirá el lote (PDF o link de pago).",
          number: "Número (con DDD)",
          numberInvalid: "Número inválido.",
          send: "Enviar",
        },
        send: {
          button: "Enviar fichas Wi-Fi",
          title: "Enviar fichas Wi-Fi",
          searchPlaceholder: "Buscar lote liberado…",
          createNow: "Crear lote ahora",
          empty: "Ningún lote liberado encontrado.",
          listTitle: "Seleccione un lote liberado",
          change: "Cambiar lote",
          toTicket: "Las fichas se enviarán a este ticket.",
          numberLabel: "Número del cliente",
          numberInvalid: "Número inválido.",
          resultPdf: "Ficha enviada en PDF.",
          resultLink: "Enlace de pago enviado.",
        },
        duration: {
          minutes: "{{count}} min",
          minutes_plural: "{{count}} min",
          hours: "{{count}} h",
          hours_plural: "{{count}} h",
          days: "{{count}} día",
          days_plural: "{{count}} días",
        },
        errors: {
          notConfigured: "Hotspot no configurado.",
          unavailable: "Hotspot no disponible en este momento.",
          noLink: "No hay enlace de pago disponible para este lote.",
        },
        devices: {
          table: {
            name: "Nombre",
            slug: "Slug",
            status: "Estado",
            lastContact: "Último contacto",
            vpn: "VPN",
            modes: "Modos de acceso",
          },
          status: {
            online: "En línea",
            offline: "Fuera de línea",
          },
          empty: "No se encontraron equipos.",
          refresh: "Actualizar",
        },
        payments: {
          filters: {
            status: "Estado",
            device: "Equipo",
            allStatuses: "Todos",
            allDevices: "Todos",
            from: "Desde",
            to: "Hasta",
          },
          status: {
            pago: "Pagado",
            pendente: "Pendiente",
            expirado: "Expirado",
          },
          table: {
            date: "Fecha",
            device: "Equipo",
            description: "Descripción",
            value: "Valor",
            status: "Estado",
            gateway: "Pasarela",
            noDevice: "Sin equipo",
            empty: "No se encontraron pagos.",
          },
        },
        summary: {
          cards: {
            online: "En línea ahora",
            leadsToday: "Leads hoy",
            leads7d: "Leads (7 días)",
            leads30d: "Leads (30 días)",
            paymentsPaid: "Pagos pagados",
            paymentsPending: "Pagos pendientes",
            paymentsExpired: "Pagos expirados",
            revenue: "Ingresos",
          },
          updatedAt: "Actualizado a las {{time}}",
          empty: "No hay datos disponibles.",
        },
      },
      metaTemplates: {
        "title": "Plantillas WhatsApp",
        "list": {
          "connection": "Conexión oficial",
          "search": "Buscar plantilla…"
        },
        "buttons": {
          "sync": "Sincronizar con Meta",
          "new": "Nueva plantilla",
          "edit": "Editar",
          "delete": "Eliminar"
        },
        "table": {
          "name": "Nombre",
          "category": "Categoría",
          "language": "Idioma",
          "status": "Estado",
          "updatedAt": "Actualizado el",
          "actions": "Acciones"
        },
        "empty": {
          "noConnectionTitle": "Ninguna conexión de WhatsApp Oficial",
          "noConnection": "Registra una conexión de WhatsApp Oficial en Conexiones para crear y gestionar plantillas aprobadas por Meta.",
          "goToConnections": "Ir a Conexiones",
          "noTemplates": "Aún no hay plantillas. Haz clic en \"Nueva plantilla\" o en \"Sincronizar con Meta\".",
          "noResults": "Ninguna plantilla coincide con la búsqueda."
        },
        "confirm": {
          "deleteTitle": "¿Eliminar la plantilla {{name}}?",
          "deleteMessage": "La plantilla se eliminará de Meta y del sistema. Las campañas que la usan dejarán de funcionar."
        },
        "toasts": {
          "synced": "Sincronizado: {{total}} plantilla(s) actualizada(s).",
          "deleted": "Plantilla eliminada.",
          "created": "Plantilla enviada a revisión de Meta.",
          "updated": "Edición enviada. La plantilla volvió a revisión de Meta.",
          "saveError": "No se pudo guardar la plantilla."
        },
        "status": {
          "APPROVED": "Aprobada",
          "PENDING": "Pendiente",
          "REJECTED": "Rechazada",
          "PAUSED": "Pausada",
          "noReason": "Meta no informó el motivo."
        },
        "category": {
          "MARKETING": "Marketing",
          "UTILITY": "Utilidad",
          "AUTHENTICATION": "Autenticación"
        },
        "categoryHelp": {
          "MARKETING": "Promociones, ofertas y avisos generales. Mayor costo por conversación.",
          "UTILITY": "Cobros, confirmaciones y actualizaciones de pedido/servicio. Recomendada para facturas.",
          "AUTHENTICATION": "Códigos de verificación. Meta define el texto; úsala solo para OTP."
        },
        "language": {
          "pt_BR": "Portugués (Brasil)",
          "en_US": "Inglés (EE. UU.)",
          "es": "Español"
        },
        "parameterFormat": {
          "POSITIONAL": "Posicional",
          "NAMED": "Con nombre"
        },
        "headerFormat": {
          "NONE": "Ninguno",
          "TEXT": "Texto",
          "IMAGE": "Imagen",
          "DOCUMENT": "Documento",
          "VIDEO": "Video"
        },
        "preview": {
          "business": "Tu empresa",
          "businessAccount": "Cuenta comercial",
          "empty": "La vista previa del mensaje aparece aquí a medida que completas el formulario.",
          "document": "documento.pdf",
          "copyCode": "Copiar código",
          "buttonPlaceholder": "Texto del botón",
          "seeAll": "Ver todas las opciones"
        },
        "editor": {
          "titleNew": "Nueva plantilla",
          "titleEdit": "Editar plantilla {{name}}",
          "close": "Cerrar",
          "cancel": "Cancelar",
          "submit": "Enviar a revisión",
          "saveEdit": "Guardar y reenviar",
          "metaError": "Meta rechazó la plantilla:",
          "editNotice": "Meta solo acepta una edición cada 24 h; al guardar, la plantilla vuelve a revisión. El nombre y el idioma no se pueden cambiar.",
          "pendingNotice": "Esta plantilla todavía está en revisión. Meta no permite editar plantillas pendientes: espera la aprobación o el rechazo.",
          "previewTitle": "Vista previa",
          "insertVariable": "Insertar variable",
          "variableName": "Nombre de la variable",
          "variableNameHelp": "Minúsculas, números y _ (ej.: nombre, vencimiento)",
          "insert": "Insertar",
          "billingVariables": "Variables sugeridas para cobro (clic para insertar):",
          "examplesTitle": "Ejemplo de cada variable (obligatorio para que Meta apruebe)",
          "format": {
            "bold": "Negrita",
            "italic": "Cursiva",
            "strike": "Tachado"
          },
          "sections": {
            "basic": "Identificación",
            "basicHelp": "Nombre único por conexión, categoría e idioma. Meta usa la categoría para revisar y cobrar.",
            "header": "Encabezado (opcional)",
            "headerHelp": "Un texto corto en negrita o un archivo multimedia en la parte superior.",
            "body": "Cuerpo",
            "bodyHelp": "Texto principal. Usa variables para nombre, valor, vencimiento, etc. e informa un ejemplo para cada una.",
            "footer": "Pie (opcional)",
            "footerHelp": "Línea corta en gris al final del mensaje.",
            "buttons": "Botones (opcional)",
            "buttonsHelp": "Hasta 10 botones: respuesta rápida, enlace, teléfono o copiar código. Las respuestas rápidas deben ir agrupadas."
          },
          "fields": {
            "whatsapp": "Conexión oficial",
            "name": "Nombre de la plantilla",
            "nameHelp": "Se convierte automáticamente a minúsculas con _ (ej.: cobro_d3)",
            "nameLocked": "Meta no permite renombrar una plantilla ya enviada",
            "category": "Categoría",
            "language": "Idioma",
            "parameterFormat": "Formato de las variables",
            "headerFormat": "Tipo de encabezado",
            "headerText": "Texto del encabezado",
            "headerTextHelp": "Hasta 60 caracteres, como máximo una variable",
            "headerVarExample": "Ejemplo para {{variable}} del encabezado",
            "headerMediaExample": "URL pública de ejemplo",
            "headerMediaHelp": {
              "IMAGE": "Enlace público a una imagen JPG/PNG (Meta la descarga para revisar).",
              "DOCUMENT": "Enlace público a un PDF de ejemplo.",
              "VIDEO": "Enlace público a un video MP4 de ejemplo."
            },
            "body": "Texto del mensaje",
            "bodyPlaceholder": "¡Hola! Tu factura vence pronto. Usa el botón Insertar variable para personalizar.",
            "footer": "Texto del pie"
          },
          "buttons": {
            "count": "{{total}}/{{max}} botones",
            "add": "Agregar botón",
            "empty": "Sin botones. Agrega respuestas rápidas o un enlace para pagar la factura.",
            "type": {
              "QUICK_REPLY": "Respuesta rápida",
              "URL": "Abrir enlace",
              "PHONE_NUMBER": "Llamar",
              "COPY_CODE": "Copiar código"
            },
            "moveUp": "Subir",
            "moveDown": "Bajar",
            "remove": "Quitar",
            "text": "Texto del botón",
            "phone": "Teléfono",
            "phoneHelp": "Con código de país, ej.: +5531999999999",
            "url": "URL",
            "urlHelp": "Puede terminar con una variable para un enlace dinámico",
            "urlExample": "Ejemplo de URL completa",
            "urlExampleHelp": "Obligatorio cuando la URL tiene variable",
            "copyCodeExample": "Código de ejemplo",
            "copyCodeHelp": "Cupón o código que el cliente copia"
          }
        },
        "validation": {
          "whatsappRequired": "Selecciona la conexión de WhatsApp Oficial.",
          "nameRequired": "Informa el nombre de la plantilla.",
          "nameFormat": "El nombre solo puede tener letras minúsculas, números y _.",
          "categoryRequired": "Selecciona la categoría.",
          "languageRequired": "Selecciona el idioma.",
          "headerTextRequired": "Informa el texto del encabezado o cambia el tipo a Ninguno.",
          "headerTextTooLong": "El encabezado debe tener como máximo {{max}} caracteres.",
          "headerOneVariable": "El encabezado acepta como máximo una variable.",
          "headerExampleRequired": "Informa un ejemplo para la variable del encabezado.",
          "headerMediaExampleRequired": "Informa una URL pública (http/https) de ejemplo para el archivo del encabezado.",
          "bodyRequired": "Informa el texto del mensaje.",
          "bodyTooLong": "El cuerpo debe tener como máximo {{max}} caracteres.",
          "bodyExampleRequired": "Informa un ejemplo para: {{vars}}.",
          "namedVariableFormat": "Nombre de variable inválido ({{vars}}): usa minúsculas, números y _, empezando por letra.",
          "positionalSequence": "Las variables posicionales deben numerarse en secuencia desde 1, sin saltos.",
          "footerTooLong": "El pie debe tener como máximo {{max}} caracteres.",
          "tooManyButtons": "Como máximo {{max}} botones.",
          "tooManyUrlButtons": "Como máximo {{max}} botones de enlace.",
          "tooManyPhoneButtons": "Solo se permite un botón de teléfono.",
          "tooManyCopyCodeButtons": "Solo se permite un botón de copiar código.",
          "buttonsGrouped": "Los botones de respuesta rápida deben ir agrupados (todos antes o todos después de los demás).",
          "buttonTextRequired": "Botón {{n}}: informa el texto.",
          "buttonTextTooLong": "Botón {{n}}: el texto debe tener como máximo {{max}} caracteres.",
          "buttonTextDuplicate": "Botón {{n}}: ya existe un botón con ese texto.",
          "buttonUrlInvalid": "Botón {{n}}: informa una URL válida que empiece con http:// o https://.",
          "buttonUrlVariable": "Botón {{n}}: la URL solo puede tener una variable, y debe ir al final.",
          "buttonUrlExampleRequired": "Botón {{n}}: informa un ejemplo de URL completa.",
          "buttonPhoneInvalid": "Botón {{n}}: informa un teléfono válido con código de país (ej.: +5531999999999).",
          "buttonCopyCodeRequired": "Botón {{n}}: informa el código de ejemplo.",
          "buttonCopyCodeTooLong": "Botón {{n}}: el código debe tener como máximo {{max}} caracteres."
        }
      },
      invoiceCampaigns: {
        details: {
          of: "de",
          open: "Ver detalles",
          searchPlaceholder: "Buscar por nombre, número, contrato, factura o documento",
          filters: {
            all: "Todas",
            sent: "Enviadas",
            failed: "Fallidas",
            skipped: "Ignoradas",
            pending: "Pendientes",
          },
          columns: {
            customer: "Cliente",
            contract: "Contrato",
            invoice: "Factura",
            dueDate: "Vencimiento",
            amount: "Valor",
            number: "Número",
            otherNumbers: "Otros números",
            result: "Resultado",
            reason: "Motivo",
            sentAt: "Enviada el",
          },
          status: {
            sent: "Enviada",
            failed: "Falló",
            pending: "Pendiente",
            skipped_optout: "Ignorada",
            skipped_dedup: "Ignorada",
            skipped_needs_template: "Ignorada",
            skipped_no_phone: "Ignorada",
            skipped_cancelled: "Cancelada",
          },
          reason: {
            skipped_optout: "El cliente pidió no recibir",
            skipped_dedup: "Esta factura ya se envió recientemente",
            skipped_needs_template: "El canal oficial exige una plantilla aprobada",
            skipped_no_phone: "Sin teléfono en el ERP",
            skipped_cancelled: "Campaña cancelada antes del envío",
          },
          alsoTried: "Alternativa:",
          empty: "No se encontraron envíos.",
          export: "Exportar a Excel",
          exporting: "Exportando...",
          sheetName: "Envíos",
          close: "Cerrar",
        },
        filters: {
          overdue: "Vencidas",
          upcoming: "Por vencer",
          alert: "Aviso de falla",
        },
        title: "Campañas de Factura",
        form: {
          name: "Nombre de la campaña",
          whatsapp: "Conexión WhatsApp",
          erpIntegration: "Integración ERP",
          filter: "Filtro de facturas",
          filterOverdue: "Vencidas",
          filterUpcoming: "Por vencer",
          daysAhead: "Días hasta el vencimiento",
          template: "Mensaje (plantilla)",
          variablesHelp: "Variables disponibles (haga clic para insertar):",
          scheduledAt: "Programar para (opcional)",
          scheduledAtHelp: "Deje en blanco para enviar inmediatamente",
          metaTemplateName: "Nombre de la plantilla Meta",
          metaTemplateNameHelp: "Obligatorio para conexiones de WhatsApp oficial",
          none: "Ninguno",
          defaultTemplate: "¡Hola {nome}! Su factura del contrato {contrato} por {valor} vence el {vencimento}.\nLínea digitable: {linhaDigitavel}\nPIX copia y pega: {pix}\nBoleto: {link}",
        },
        buttons: {
          preview: "Previsualizar",
          createAndSend: "Crear y enviar",
          cancel: "Cancelar campaña",
          close: "Cerrar",
        },
        preview: {
          title: "Previsualización de la campaña",
          total: "Total a enviar",
          optout: "Opt-out",
          dedup: "Ya enviadas (7 días)",
          needsTemplate: "Sin plantilla Meta",
          samples: "Ejemplos de mensajes",
          noSamples: "Ningún ejemplo devuelto para los filtros elegidos.",
        },
        table: {
          type: "Tipo",
          name: "Nombre",
          status: "Estado",
          pending: "Pendientes",
          sent: "Enviadas",
          failed: "Fallidas",
          skipped: "Omitidas",
          createdAt: "Creada en",
          actions: "Acciones",
          empty: "Aún no hay campañas de factura creadas.",
        },
        status: {
          pending: "Pendiente",
          scheduled: "Programada",
          running: "En curso",
          processing: "En curso",
          finished: "Finalizada",
          completed: "Finalizada",
          cancelled: "Cancelada",
          canceled: "Cancelada",
          failed: "Falló",
        },
        validation: {
          nameRequired: "Informe el nombre de la campaña.",
          whatsappRequired: "Seleccione la conexión WhatsApp.",
          erpRequired: "Seleccione la integración ERP.",
          templateRequired: "Informe el mensaje de la campaña.",
          daysAheadInvalid: "Los días hasta el vencimiento deben ser un entero mayor o igual a cero.",
          metaTemplateRequired: "Informe el nombre de la plantilla Meta para conexiones oficiales.",
        },
        toasts: {
          created: "Campaña de factura creada con éxito.",
          cancelled: "Campaña cancelada.",
        },
        confirmationModal: {
          cancelTitle: "Cancelar la campaña",
          cancelMessage: "Los envíos pendientes serán interrumpidos. Esta acción no se puede deshacer.",
        },
      },
      queueIntegrationModal: {
        types: {
          SGP: "ERP SGP",
          IXC: "ERP IXC",
          ISP_IA: "IA de Soporte (ISP)",
          HOTSPOT: "Hotspot (Seu Hotspot)",
          HOSPEDAGEM_CONECTOR: "Conector de hospedaje (sitio)",
          HOSPEDAGEM_IA: "Agente de Hospedaje",
        },
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          tipoIntegracao: "Tipo de integración",
          sgpIeSenha: "Usuario informa contraseña",
          sgpUrl: "SGP URL",
          sgpWidePayToken: "Widepay Token",
          sgpApp: "App (integración URA)",
          sgpToken: "Token de la app",
          sgpTokenToggle: "Mostrar/ocultar token",
          sgpMode: "Modo",
          sgpModeHelp: "App + Token se registran en el SGP (Integraciones → URA). Con ellos el sistema consulta por CPF sin pedir la contraseña del abonado y habilita campañas de factura y la IA de soporte en el SGP. Déjelos en blanco para usar solo la central del abonado.",
          ixcUrl: "URL base del IXC",
          ixcToken: "Token de la API IXC",
          timeoutMs: "Timeout (ms) — opcional",
          erpIntegrationId: "Integración ERP",
          openaiApiKey: "Clave de la API OpenAI",
          model: "Modelo",
          handoffQueueId: "Cola para transferencia (handoff)",
          receiptQueueId: "Cola para comprobantes (foto/PDF)",
          receiptQueueKeep: "Mantener la cola actual",
          receiptQueueIdHelp: "Cuando el cliente ya identificado envía una foto o PDF durante el chatbot, la IA lo lee como comprobante, lo compara con las facturas abiertas y el ticket pasa a esta cola con una nota interna.",
          maxTurns: "Máximo de turnos",
          promptExtra: "Instrucciones extra del proveedor",
          promptExtraHelp: "Texto añadido al prompt de la IA (horarios, políticas, tono de voz, etc.)",
          none: "Ninguno",
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
          hotspotBaseUrl: "URL del Hotspot",
          hotspotApiKey: "Clave de API",
          hotspotTest: "Probar conexión",
          hotspotDefaultDevice: "Equipo predeterminado",
          hotspotDefaultTabela: "Tabla de precios predeterminada",
          hotspotHelp: "Genere la clave en el panel del hotspot en Configuración → Integraciones.",
          hospedagemProvider: "Proveedor",
          hospedagemBaseUrl: "URL del sitio",
          hospedagemApiKey: "Clave de API",
          hospedagemTest: "Probar conexión",
          hospedagemPropostaHabilitada: "El sitio acepta propuestas del agente (activar solo después de publicar el sitio)",
          hospedagemPropostaHabilitadaHelp:
            "Desactivado: el agente cierra con prerreserva, como siempre. Actívelo solo cuando el sitio tenga publicada la ruta de propuestas; entonces el agente genera el enlace de la propuesta, cotiza con el precio de tarjeta y sigue el guion de venta.",
          hospedagemIntegrationId: "Conector de hospedaje",
          openaiApiKeyOptionalHelp: "Vacío = usa la clave de la plataforma.",
          nomeAgente: "Nombre del agente",
          nomeEmpresa: "Nombre de la empresa",
          persona: "Persona del agente",
          personaHelp: "Instrucciones para el agente: quién es, tono, reglas — el texto que sigue en la conversación.",
          permitirPreReserva: "Permitir crear pre-reserva",
          pedirEmailParaReserva: "Pedir correo electrónico para reservar",
          voiceMode: "Respuesta en audio",
          voiceModeHelp: "Cuando el agente responde con una nota de voz",
          voiceModeMirror: "Cuando el cliente envía audio (predeterminado)",
          voiceModeAlways: "Siempre que sea posible",
          voiceModeOff: "Nunca (solo texto)",
          voice: "Voz (OpenAI TTS)",
        },
        hospedagem: {
          vendaTitle: "Venta y apertura",
          responderPrimeiraMensagem: "Responder al primer mensaje del cliente",
          responderPrimeiraMensagemHelp: "Si está activo, el agente responde directo a lo que el cliente ya escribió (anuncio de origen, pregunta) en vez de la apertura fija. Si es solo un saludo, se mantiene la apertura fija.",
          fichaEmpresa: "Ficha de la empresa",
          fichaEmpresaHelp: "Datos fijos que la IA puede citar: dirección, reglas de la casa, horario de check-in y check-out, mascotas, estacionamiento etc.",
          escadaTitle: "Escalera de condiciones",
          escadaHelp: "Condiciones que la IA puede ofrecer, una a la vez y en este orden, cuando el cliente duda por el precio (hasta 4). Solo se usa cuando el sitio del conector acepta propuestas; en temporada alta y feriados la IA no ofrece condición especial.",
          escadaEmpty: "Sin escalones: la IA no ofrece condición especial.",
          addDegrau: "Agregar escalón",
          degrauN: "Escalón {{n}}",
          moveUp: "Subir",
          moveDown: "Bajar",
          remove: "Quitar",
          tipo: "Condición",
          tipoSelect: "Elija la condición",
          tipos: {
            ISENTAR_LIMPEZA: "Eximir la limpieza",
            INCLUIR_EXTRA: "Incluir servicio extra",
            DESCONTO_PCT: "Descuento %",
            NOITE_EXTRA: "Noche extra con descuento",
          },
          pctDesconto: "Descuento (%)",
          pctNoite: "Descuento en la noche extra (%)",
          pctHelp: "Número entero de 1 a {{max}}.",
          servicoExtraNome: "Servicio extra",
          servicoExtraNomeHelp: "Nombre del servicio extra tal como está en el sitio.",
          frase: "Cómo lo presenta la IA",
          fraseHelp: "Frase que la IA usa para ofrecer esta condición al cliente.",
          periodosTitle: "Períodos sin escalera (temporada alta)",
          periodosHelp: "Las estadías con alguna noche en estos períodos no reciben condición especial.",
          periodosEmpty: "Ningún período registrado.",
          addPeriodo: "Agregar período",
          periodoN: "Período {{n}}",
          rotulo: "Nombre del período",
          rotuloHelp: "P. ej.: Año Nuevo, vacaciones de julio.",
          anual: "Se repite cada año",
          anualOnHelp: "Fechas en formato DD/MM.",
          anualOffHelp: "Solo en las fechas elegidas (con año).",
          sim: "Sí",
          nao: "No",
          inicio: "Inicio",
          fim: "Fin",
          incluirFeriadosNacionais: "Feriados nacionales y Carnaval también sin escalera",
          incluirFeriadosHelp: "Bloquea la escalera en el fin de semana largo de cada feriado nacional y en Carnaval.",
          errors: {
            fixFields: "Corrija los campos de la escalera de condiciones y de los períodos sin escalera.",
            tipoRequired: "Elija la condición.",
            maxDegraus: "Máximo de 4 escalones: quite este.",
            pctDesconto: "Ingrese un número entero de 1 a 10.",
            pctNoite: "Ingrese un número entero de 1 a 50.",
            extraRequired: "Ingrese el nombre del servicio extra.",
            fraseRequired: "Escriba cómo la IA presenta esta condición.",
            rotuloRequired: "Dé un nombre al período.",
            diaMesInvalid: "Fecha inválida (use DD/MM).",
            dataInvalid: "Fecha inválida.",
            fimAntesInicio: "El fin debe ser igual o posterior al inicio.",
          },
        },
        buttons: {
          testErp: "Probar conexión",
          testErpSaveFirst: "Guarde la integración primero para probar la conexión",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          erpHealthOk: "Conexión con el ERP OK",
          erpHealthFail: "Fallo en la conexión con el ERP",
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
          hotspotTestOk: "Conectado al tenant {{name}}",
          hospedagemTestOk: "Conexión con el sitio OK",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowedWhatsapps: "Conexiones que puede atender",
          allowedWhatsappsAll: "Todas",
          allowedWhatsappsHelp: "Ninguna marcada = todas. Con conexiones marcadas, el usuario solo ve, abre y responde sus conversaciones.",
        },
        tabs: {
          general: "General",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          pending: "Pendientes",
          closed: "Cerrados",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        status: {
          open: "En atención",
          pending: "Esperando",
          closed: "Finalizado",
          group: "Grupo",
        },
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        connectionRequired: "Seleccione una conexión",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          channelsGroup: "Canales y API",
          searchMenu: "Buscar menú…",
          phraseLists: "Listas de frases",
          flowbuilders: "Flujos de conversación",
          files: "Archivos",
          birthdaySettings: "Cumpleaños",
          platform: "Plataforma",
          configGroup: "Administración",
          automation: "Automatización",
          billingGroup: "Cobranza y Proveedor",
          management: "Gestión",
          attendance: "Atención",
          networkAlerts: "Problema General",
          hotspot: "Hotspot",
          aiPlatform: "IA de la plataforma",
          systemResources: "Servidor",
          dashboard: "Dashboard",
          connections: "Canales de comunicación",
          chatsTempoReal: "Panel en tiempo real",
          supervision: "Supervisión",
          ratings: "Evaluaciones",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Colas de atención",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Equipo y usuarios",
          settings: "Preferencias del sistema",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API e integraciones",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          resellerFinance: "Finanzas de la reventa",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Prompts de IA",
          aiLearning: "Aprendizaje de la IA",
          attendanceInsights: "Métricas de atención",
          allConnections: "Admin conexiones",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          invoiceCampaigns: "Campañas de Factura",
          metaTemplates: "Plantillas WhatsApp",
          billingRules: "Regla de cobranza",
          list: "Listados",
          listContacts: "Listados de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      resellerFinance: {
        title: "Finanzas",
        subtitlePlatform: "Ingresos de la plataforma: empresas y revendedores directos",
        subtitleReseller: "Ingresos de tus empresas y tu factura con la plataforma",
        month: "Mes",
        stats: {
          receivable: "Por cobrar",
          paid: "Cobrado",
          overdue: "Atrasado",
          mrr: "MRR",
          mrrHint: "Suma de los planes de las empresas activas",
          payable: "Mi factura",
          dueOn: "Vence el",
          noPayable: "Ninguna factura abierta",
          invoices: "facturas",
          companies: "empresas",
          delinquentCompanies: "empresas morosas",
          noOverdue: "Todo al día",
        },
        status: { open: "Abierta", paid: "Pagada", overdue: "Vencida", none: "Sin factura" },
        delinquent: { title: "Morosos", hint: "Facturas abiertas con vencimiento pasado" },
        byCompany: { title: "Por empresa" },
        byPlan: { title: "Por plan", hint: "Empresas activas × valor del plan" },
        table: {
          company: "Empresa",
          plan: "Plan",
          value: "Valor",
          dueDate: "Vencimiento",
          lastInvoice: "Última factura",
          overdueDays: "Días de atraso",
          days: "días",
          actions: "Acciones",
          companies: "Empresas",
          amount: "Valor",
          mrr: "MRR",
          inactive: "Inactiva",
        },
        actions: { invoices: "Facturas", company: "Empresa" },
        empty: {
          title: "Ninguna empresa todavía",
          message: "Registra empresas para seguir facturas, atrasos y MRR aquí.",
          action: "Registrar empresa",
        },
      },
      invite: {
        title: "Invitación",
        loading: "Verificando invitación...",
        invitedTo: "Has sido invitado a",
        instruction: "Define tu contraseña para empezar.",
        form: {
          email: "Correo",
          name: "Tu nombre",
          namePlaceholder: "Cómo quieres que te llamen",
          password: "Contraseña",
          passwordHelper: "Mínimo {{min}} caracteres",
          confirm: "Confirmar contraseña",
        },
        buttons: { submit: "Crear acceso y entrar" },
        alreadyHaveAccount: "¿Ya tienes acceso? Entrar",
        goToLogin: "Ir al login",
        errors: {
          passwordMin: "La contraseña debe tener al menos {{min}} caracteres.",
          passwordMismatch: "Las contraseñas no coinciden.",
        },
        toasts: { accepted: "¡Acceso creado! Bienvenido." },
        notFound: { title: "Invitación no encontrada", message: "Este enlace es inválido o ya fue utilizado. Pide una nueva invitación a tu proveedor." },
        expired: { title: "Invitación expirada", message: "Esta invitación venció. Pide una nueva invitación a tu proveedor." },
        generic: { title: "No se pudo abrir la invitación", message: "Inténtalo de nuevo en unos instantes. Si persiste, pide una nueva invitación." },
      },
      onboarding: {
        title: "Primeros pasos",
        subtitle: "Completa estos pasos para empezar a atender.",
        hide: "Ocultar",
        progress: "completados",
        items: {
          connection: { title: "Conectar WhatsApp", hint: "Escanea el código QR o conecta la API oficial" },
          queue: { title: "Crear una cola", hint: "Organiza la atención por sector" },
          team: { title: "Invitar al equipo", hint: "Agrega al menos un usuario más" },
          quickMessage: { title: "Crear una respuesta rápida", hint: "Agiliza respuestas frecuentes" },
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "MXN",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
          type: "Tipo",
          typePlatform: "Plataforma",
          typeReseller: "Revendedor",
          typeCompany: "Empresa",
          domain: "Dominio",
          slug: "Subdominio",
          slugHelper: "Minúsculas, números y guion",
          slugRequired: "El revendedor necesita un subdominio",
          invalidSlug: "Subdominio inválido o reservado",
          customDomain: "Dominio propio",
          customDomainHelper: "Ej.: panel.suempresa.com (sin http/puerto)",
          invalidCustomDomain: "Dominio propio inválido",
          allowCustomBrand: "Marca propia",
          maxCompanies: "Límite de empresas",
          maxCompaniesHelper: "Vacío = sin límite",
          invalidMaxCompanies: "Límite de empresas inválido",
          openPanel: "Abrir panel",
          invoices: "Facturas",
          emptyTitle: "Ninguna empresa todavía",
          emptyMessage: "Las empresas que registres aparecerán aquí.",
          dueDateHelper: "Sin fecha: 30 días a partir de hoy",
          invite: "Invitar",
          inviteSent: "Invitación generada. Se envió un correo al administrador de la empresa.",
          inviteError: "No se pudo generar la invitación.",
          inviteDialogTitle: "Invitación de acceso",
          inviteDialogText: "Envía este enlace al administrador de",
          inviteCopy: "Copiar enlace",
          inviteCopied: "Enlace copiado.",
          inviteCopyError: "No se pudo copiar. Selecciona el enlace y cópialo manualmente.",
          inviteExpires: "Válido hasta",
          inviteClose: "Cerrar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          platformPlan: "Plataforma",
          readOnly: "Plan de la plataforma: solo lectura",
          perActiveCompanyAmount: "Valor por empresa activa (R$)",
          perActiveCompanyAmountHelper: "Sumado al valor fijo, por empresa activa del revendedor, al generar la factura",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programas",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            ratingButtons: "Evaluación por botones",
            ratingButtonsHelp: "Al cerrar la atención el cliente responde tocando 👍 Excelente / 😐 Regular / 👎 Malo (WhatsApp no oficial). En los demás canales sigue por texto.",
            typingIndicator: "Mostrar \"escribiendo…\"",
            typingIndicatorHelp: "El cliente ve cuando el agente está escribiendo o grabando audio, y el agente ve cuando el cliente escribe (WhatsApp no oficial).",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar/Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar el ticket.",
          },
        },
      },
      conversation: {
        unread: "{{count}} mensaje no leído",
        unread_plural: "{{count}} mensajes no leídos",
        reactions: {
          react: "Reaccionar",
          more: "Más emojis",
          you: "Tú",
          clickToRemove: "clic para quitar",
          unavailable: "No se pudo enviar la reacción.",
          unsupported: "Este canal no acepta reacciones.",
        },
        emojiPicker: {
          search: "Buscar emoji",
          notFound: "Ningún emoji encontrado",
          results: "Resultados",
          recent: "Recientes",
          people: "Caritas y personas",
          nature: "Animales y naturaleza",
          foods: "Comida y bebida",
          activity: "Actividades",
          places: "Viajes y lugares",
          objects: "Objetos",
          symbols: "Símbolos",
          flags: "Banderas",
        },
        sending: {
          sending: "Enviando…",
          failed: "No enviado",
          retry: "Reintentar",
          discard: "Descartar",
          voice: "Mensaje de voz",
        },
        jump: {
          searching: "Buscando el mensaje…",
          loaded: "{{count}} cargado",
          loaded_plural: "{{count}} cargados",
          cancel: "Detener la búsqueda",
          notFound: "Ese mensaje no está en esta conversación.",
        },
        recorder: {
          label: "Grabación de audio",
          time: "Tiempo de grabación",
          discard: "Descartar grabación",
          pause: "Pausar grabación",
          resume: "Continuar grabación",
          send: "Enviar audio",
        },
        gallery: {
          title: "Fotos y videos de la conversación",
          counter: "{{current}} de {{total}}",
          previous: "Anterior",
          next: "Siguiente",
          download: "Descargar",
          close: "Cerrar",
          open: "Abrir archivo {{n}}",
          imageFailed: "No se pudo cargar la imagen.",
          videoFailed: "Este video no se puede reproducir en el navegador.",
        },
        mentions: {
          participant: "participante",
          listLabel: "Participantes del grupo",
          noNumber: "Número no informado",
          admin: "Admin",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
          of: "Facturas de",
          back: "Volver",
        },
      },
      webchatVisitor: {
        title: "Cliente del webchat",
        phone: "WhatsApp informado",
        unconfirmed: "no confirmado",
        noPhone: "No informó",
        since: "Primera visita",
        lastSeen: "Visto por última vez",
        maybeSame: "Puede ser el mismo cliente de:",
      },
      backendErrors: {
        ERR_WEBCHAT_OUTBOUND: "El webchat solo responde a quien abrió la página; no se puede iniciar una conversación por él.",
        ERR_WEBCHAT_TRANSFER: "Los tickets del webchat no pueden pasar a una conexión de WhatsApp (ni al revés).",
        ERR_WEBCHAT_UNSUPPORTED: "Eso no existe en el webchat.",
        ERR_WEBCHAT_DISABLED: "La página de atención (webchat) está desactivada: el cliente no vería la respuesta. Actívela en Conexiones para responder.",
        ERR_META_COEX_ONLY: "Esta conexión no es de coexistencia.",
        ERR_META_COEX_SYNC_EXPIRED: "Meta solo acepta el pedido de historial en las 24 h siguientes a la conexión.",
        ERR_REACTION_INVALID_EMOJI: "Este emoji no se puede usar como reacción.",
        ERR_REACTION_INVALID_TARGET: "No se puede reaccionar a este mensaje.",
        ERR_REACTION_TICKET_CLOSED: "La atención está cerrada: reábrela para reaccionar.",
        ERR_REACTION_UNSUPPORTED_CHANNEL: "Este canal no acepta reacciones.",
        ERR_OFICIAL_MEDIA_TOO_LARGE: "Archivo demasiado grande para la API oficial (imagen hasta 5 MB, audio y video hasta 16 MB, documento hasta 100 MB).",
        ERR_OFICIAL_MEDIA_UNSUPPORTED: "La API oficial de WhatsApp no acepta este tipo de archivo.",
        ERR_INVALID_MENTIONS: "No se pudo mencionar a los participantes. Elígelos de nuevo en la lista.",
        ERR_MENTIONS_LIMIT: "Demasiadas personas mencionadas: el límite es 50 por mensaje.",
        ERR_ERP_CONTRACT_NOT_LINKED: "Este contrato no pertenece al cliente vinculado a este contacto.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_TOO_MANY_LOGIN_ATTEMPTS: "Demasiados intentos de inicio de sesión. Espere 15 minutos e intente de nuevo.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_EDITING_WAPP_MSG: "No fue posible editar el mensaje en WhatsApp.",
        ERR_EDIT_WINDOW_EXPIRED: "WhatsApp solo permite editar hasta 15 minutos después del envío.",
        ERR_EDIT_NOT_SUPPORTED_CHANNEL: "Este canal no permite editar mensajes.",
        ERR_EDIT_NOT_OWN_MESSAGE: "Solo puedes editar mensajes enviados por ti.",
        ERR_EDIT_EMPTY: "El mensaje no puede quedar vacío.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_ALLOWED_WHATSAPPS_INVALID: "Ninguna de las conexiones marcadas existe. Desmarque y elija de nuevo (o déjelo vacío para todas).",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
        ERR_DOMAIN_NOT_POINTING: "El dominio debe apuntar (CNAME) a app.{{baseDomain}} antes de guardarse.",
        ERR_RESELLER_INACTIVE: "El revendedor responsable de esta cuenta está inactivo. Contacte al soporte.",
        ERR_RESELLER_LIMIT: "Se alcanzó el límite de empresas del revendedor.",
        ERR_PLAN_NOT_ALLOWED: "Este plan no está disponible para esta empresa.",
        ERR_TERMS_REQUIRED: "Debes aceptar los términos de uso para registrarte.",
        ERR_TERMS_NOT_CONFIGURED: "No hay términos de uso configurados para esta empresa.",
        ERR_SLUG_IN_USE: "Este subdominio ya está en uso.",
        ERR_DOMAIN_IN_USE: "Este dominio ya está en uso por otra empresa.",
        ERR_INVALID_SLUG: "Subdominio inválido o reservado. Use letras minúsculas, números y guiones.",
        ERR_INVALID_DOMAIN: "Dominio inválido. Informe solo el host (ej.: panel.suempresa.com), sin http ni puerto.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la test del envio",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        chooseAStream: "Elige una transmisión",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        forward: "Reenviar",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Group Name",
          create: "Create",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",
        inheritedHint: "Heredado del revendedor/plataforma hasta que lo cambies",
        termsUrl: "Enlace de los términos de uso",
        termsUrlHint: "Vacío = no se exige aceptación",
        termsVersion: "Versión de los términos",
        termsVersionHint: "Cambiar la versión exige que todas las empresas acepten de nuevo",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      },
    },
  },
};

export { messages };
